import React from 'react'
import { Box } from "grommet"

import HealthStatusServiceConnection from './HealthStatusServiceConnection'
import HealthStatusServiceBouncer from './HealthStatusServiceBouncer'
import HealthStatusServiceBookie from './HealthStatusServiceBookie'
import HealthStatusServiceOptionsRisk from './HealthStatusServiceOptionsRisk'
import HealthStatusServiceJuno from './HealthStatusServiceJuno'
import HealthStatusServiceJunoAggregatorConsumer from './HealthStatusServiceJunoAggregatorConsumer'
import HealthStatusServiceASE from './HealthStatusServiceASE'
import HealthStatusServiceAggregator from './HealthStatusServiceAggregator'
import HealthStatusServiceAlgoServerExec from './HealthStatusServiceAlgoServerExec'
import HealthStatusServiceEdge from './HealthStatusServiceEdge'
import HealthStatusServiceFix from './HealthStatusServiceFix'
import HealthStatusServiceKafka from './HealthStatusServiceKafka'
import HealthStatusServiceAlertEngine from './HealthStatusServiceAlertEngine'
import HealthStatusServiceLedgerS3Search from './HealthStatusServiceLedgerS3Search'
import HealthStatusServiceStager from './HealthStatusServiceStager'
import HealthStatusServiceOptionsApp from './HealthStatusServiceOptionsApp'
import HealthStatusServicePositionator from './HealthStatusServicePositionator'
import HealthStatusServiceTTHAProxy from './HealthStatusServiceTTHAProxy'
import HealthStatusServiceMDSStreamManager from './HealthStatusServiceMDSStreamManager'

export const HealthStatusServiceDataView = ({ sessionData, sessionType, nodeName, envName, serviceGroup }) => {
    return (
        <>
            {sessionType === 'connections' && sessionData &&
                Object.keys(sessionData).length > 0 &&
                <Box>
                    <HealthStatusServiceConnection env={envName} data={sessionData} serviceGroup={serviceGroup}/>
                </Box>
            }

            {(sessionType === 'ledger_s3_consumer' || sessionType === 'ledger_search_consumer') && sessionData &&
                Object.keys(sessionData).length > 0 &&
                <Box>
                    <HealthStatusServiceLedgerS3Search data={sessionData} />
                </Box>
            }

            {sessionType === 'accounts' && sessionData &&
                Object.keys(sessionData).length > 0 &&
                <Box>
                    <HealthStatusServiceBouncer data={sessionData} nodeName={nodeName} />
                </Box>
            }

            {(sessionType === 'kafka_uploader' || sessionType === 'ledger_up') &&
                sessionData &&
                Object.keys(sessionData).length > 0 &&
                <Box>
                    <HealthStatusServiceKafka env={envName} data={sessionData} />
                </Box>
            }

            {(sessionType === 'bookie' || sessionType === 'imbookie') && sessionData &&
                Object.keys(sessionData).length > 0 &&
                <Box>
                    <HealthStatusServiceBookie env={envName} data={sessionData} />
                </Box>
            }

            {(sessionType === 'options') && sessionData &&
                Object.keys(sessionData).length > 0 &&
                <Box>
                    <HealthStatusServiceOptionsApp data={sessionData} />
                </Box>
            }

            {(sessionType === 'options_risk') && sessionData &&
                Object.keys(sessionData).length > 0 &&
                <Box>
                    <HealthStatusServiceOptionsRisk data={sessionData} />
                </Box>
            }

            {sessionType === 'juno_up' && sessionData &&
                Object.keys(sessionData).length > 0 &&
                <Box>
                    <HealthStatusServiceJuno data={sessionData} nodeName={nodeName} />
                </Box>
            }

            {sessionType === 'juno_aggregator_consumer' && sessionData &&
                Object.keys(sessionData).length > 0 &&
                <Box>
                    <HealthStatusServiceJunoAggregatorConsumer data={sessionData} nodeName={nodeName} />
                </Box>
            }

            {sessionType === 'algoserver_exec' && sessionData &&
                Object.keys(sessionData).length > 0 &&
                <Box>
                    <HealthStatusServiceAlgoServerExec data={sessionData} />
                </Box>
            }

            {sessionType === 'ase' && sessionData &&
                Object.keys(sessionData).length > 0 &&
                <Box>
                    <HealthStatusServiceASE data={sessionData} />
                </Box>
            }

            {sessionType === 'aggregator' && sessionData &&
                Object.keys(sessionData).length > 0 &&
                <Box>
                    <HealthStatusServiceAggregator data={sessionData} />
                </Box>
            }

            {sessionType === 'users' && sessionData &&
                Object.keys(sessionData).length > 0 &&
                <Box>
                    <HealthStatusServiceEdge data={sessionData} />
                </Box>
            }

            {sessionType === 'fixsessions' && sessionData &&
                Object.keys(sessionData).length > 0 &&
                <Box>
                    <HealthStatusServiceFix data={sessionData} env={envName} />
                </Box>
            }
            {sessionType === 'alert_engine' && sessionData &&
                Object.keys(sessionData).length > 0 &&
                <Box>
                    <HealthStatusServiceAlertEngine data={sessionData} env={envName} />
                </Box>
            }

            {sessionType === 'stager' && sessionData &&
                Object.keys(sessionData).length > 0 &&
                <Box>
                    <HealthStatusServiceStager data={sessionData} nodeName={nodeName} />
                </Box>
            }

            {sessionType === 'Positionator' && sessionData &&
                Object.keys(sessionData).length > 0 &&
                <Box>
                    <HealthStatusServicePositionator data={sessionData} nodeName={nodeName} />
                </Box>
            }

            {sessionType === 'tthaproxy' && sessionData &&
                Object.keys(sessionData).length > 0 &&
                <Box>
                    <HealthStatusServiceTTHAProxy data={sessionData} nodeName={nodeName} />
                </Box>
            }

            {sessionType === 'mds_stream_manager' && sessionData &&
                Object.keys(sessionData).length > 0 &&
                <Box>
                    <HealthStatusServiceMDSStreamManager data={sessionData} nodeName={nodeName} />
                </Box>
            }

        </>
    )
}
export default HealthStatusServiceDataView
